export const UrlUtils = {
  getParamValue(url, param) {
    const result = new URL(url).searchParams.get(param);

    return result || '';
  }
};



// WEBPACK FOOTER //
// ./src/utils/UrlUtils.js